/**
 * Client-side merge of LLM events with user corrections (mirrors server/lib/resolveSchoolEvent.js).
 */

function cleanText(value) {
  return String(value || "")
    .replace(/\s+/g, " ")
    .trim();
}

export function normalizeSchoolDate(value) {
  const v = cleanText(value);
  return /^\d{4}-\d{2}-\d{2}$/.test(v) ? v : "";
}

export function normalizeSchoolTime(value) {
  if (value === null || value === undefined || value === "") return null;
  const v = cleanText(value);
  return /^([01]\d|2[0-3]):[0-5]\d$/.test(v) ? v : null;
}

/**
 * @param {object|null|undefined} raw
 * @param {object|null|undefined} corrections
 * @param {number} index
 * @returns {object|null}
 */
export function resolveSchoolEvent(raw, corrections, index) {
  if (!raw) return null;
  if (corrections?.wrongByIndex?.[index]) return null;

  const override = corrections?.userOverrides?.[index];
  if (!override || typeof override !== "object") return raw;

  const merged = { ...raw, ...override };
  const time = normalizeSchoolTime(merged.time);
  merged.time = time;
  merged.date = normalizeSchoolDate(merged.date) || raw.date || "";
  if (time) {
    merged.all_day = false;
  } else if (override.all_day === true) {
    merged.all_day = true;
    merged.time = null;
  }
  return merged;
}

/**
 * @param {object|null|undefined} corrections
 * @param {number} index
 * @returns {boolean}
 */
export function isSchoolEventDismissed(corrections, index) {
  return !!corrections?.wrongByIndex?.[index];
}

/**
 * @param {object|null|undefined} corrections
 * @param {number} index
 * @returns {boolean}
 */
export function hasSchoolEventOverride(corrections, index) {
  return !!corrections?.userOverrides?.[index];
}

/**
 * @param {object|null|undefined} corrections
 * @param {number} index
 * @returns {boolean}
 */
export function isSchoolEventDone(corrections, index) {
  return !!corrections?.doneByIndex?.[index];
}

/**
 * Event suppressed because the same date + match_key already exists.
 * @param {object|null|undefined} event
 */
export function isSchoolEventDuplicate(event) {
  const d = event?.duplicate_of;
  if (!d || typeof d !== "object" || Array.isArray(d)) return false;
  return Boolean(d.sourceId || d.extractionId);
}
